import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const cancelCheckout = unaryRpc({
  name: "cancelCheckout" as const,
  input: z.object({
    marketplaceOrderId: zExt.objectId(),
    merchantOrderIds: z.array(zExt.objectId()).optional(),
  }),
  output: z.void(),
});
